import { getMsg } from 'app/shared/utils/comUtil'
import * as React from 'react'

const PgI18n: React.FC = () => {
    //TEST STRING
    const TEST_FIRST = '테스트%s 테스트%s 테스트%s'
    return (
        <>
            <p>언어 변환 테스트</p>
            <p>원본: </p>
            <p style={{ color: 'red' }}>{TEST_FIRST}</p>
            <br />
            <p>getMsg(TEST_FIRST): </p>
            <p style={{ color: 'red' }}>{getMsg(TEST_FIRST)}</p>
            <br />
            <p>getMsg(TEST_FIRST, '1번', '2번'): </p>
            <p style={{ color: 'red' }}>{getMsg(TEST_FIRST, '1번', '2번')}</p>
            <br />
            <p>getMsg(TEST_FIRST, '1번', '2번', '3번', '4번'):</p>
            <p style={{ color: 'red' }}>
                {getMsg(TEST_FIRST, '1번', '2번', '3번', '4번')}
            </p>
            <br />
            <p>getMsg('그냥 호출', '1번', '2번', '3번', '4번'):</p>
            <p style={{ color: 'red' }}>
                {getMsg('그냥 호출', '1번', '2번', '3번', '4번')}
            </p>
        </>
    )
}

export default PgI18n
